// angular2-toaster 互換の最小 vendored 実装 (Angular 19 対応版が無いため)。
// digital-auction 由来のコードは ToasterService.pop(type, title, body) と
// <toaster-container [toasterconfig]> しか使わないので、その API だけ提供する。
// 見た目は Bootstrap4 (CoreUI) の alert クラスを使った右上トースト。
import {CommonModule} from '@angular/common';
import {Component, Injectable, ModuleWithProviders, NgModule} from '@angular/core';
import {Subject} from 'rxjs';

export interface Toast {
  id: number;
  type: string;
  title?: string;
  body?: string;
}

// 旧 API 互換 (app.component.ts が new ToasterConfig({...}) している)。設定値は使わない。
export class ToasterConfig {
  constructor(public config: Record<string, unknown> = {}) {
    Object.assign(this, config);
  }
}

@Injectable({providedIn: 'root'})
export class ToasterService {
  private seq = 0;
  readonly toasts$ = new Subject<Toast>();

  pop(type: string, title?: string, body?: string): void {
    this.toasts$.next({id: ++this.seq, type, title, body});
  }

  popAsync(type: string, title?: string, body?: string): void {
    this.pop(type, title, body);
  }

  clear(): void {
    this.toasts$.next({id: -1, type: 'clear'});
  }
}

@Component({
    standalone: false,
  selector: 'toaster-container',
  template: `
    <div class="ap-toaster">
      <div *ngFor="let t of toasts" class="alert alert-dismissible fade show"
           [class.alert-success]="t.type === 'success'"
           [class.alert-danger]="t.type === 'error' || t.type === 'danger'"
           [class.alert-warning]="t.type === 'warning'"
           [class.alert-info]="t.type === 'info' || t.type === 'note'"
           role="alert">
        <strong *ngIf="t.title">{{ t.title }}</strong>
        <div *ngIf="t.body">{{ t.body }}</div>
        <button type="button" class="close" (click)="dismiss(t)"><span>&times;</span></button>
      </div>
    </div>
  `,
  styles: [`
    .ap-toaster {
      position: fixed;
      top: 70px;
      right: 20px;
      z-index: 10500;
      width: 320px;
    }
    .ap-toaster .alert {
      box-shadow: 0 2px 8px rgba(0, 0, 0, .25);
    }
  `],
  // 旧 <toaster-container [toasterconfig]="..."> 互換で受けるだけの入力
  inputs: ['toasterconfig'],
})
export class ToasterContainerComponent {
  toasterconfig: unknown;
  toasts: Toast[] = [];

  constructor(private toaster: ToasterService) {
    this.toaster.toasts$.subscribe(t => {
      if (t.type === 'clear') {
        this.toasts = [];
        return;
      }
      this.toasts = [...this.toasts, t];
      // angular2-toaster の既定 timeout 相当 (5 秒で自動消滅)
      setTimeout(() => this.dismiss(t), 5000);
    });
  }

  dismiss(toast: Toast): void {
    this.toasts = this.toasts.filter(t => t.id !== toast.id);
  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [ToasterContainerComponent],
  exports: [ToasterContainerComponent],
})
export class ToasterModule {
  static forRoot(): ModuleWithProviders<ToasterModule> {
    return {ngModule: ToasterModule, providers: []};
  }
}
